import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { Beaker } from 'react-bootstrap-icons';
import { Organization } from '../../../models';
import styles from './SandboxEnvironmentBanner.module.scss';

interface SandboxEnvironmentBannerProps {
  organization: Organization | null;
}

/** Banner when the active org is sandbox (not production); styled for light and dark theme. */
const SandboxEnvironmentBanner: React.FC<SandboxEnvironmentBannerProps> = ({
  organization,
}) => {
  const navigate = useNavigate();

  if (!organization?.isSandbox) {
    return null;
  }

  return (
    <div className={styles.shell} role="status" aria-live="polite">
      <div className={`${styles.glass} position-relative`}>
        <div className={styles.shimmer} aria-hidden />
        <div className="px-3 py-3 d-flex flex-column flex-md-row align-items-stretch align-items-md-center justify-content-between gap-3">
          <div className="d-flex align-items-start gap-3 min-w-0">
            <div className={styles.iconWrap} aria-hidden>
              <Beaker size={20} />
            </div>
            <div className="min-w-0 pt-0 pt-md-1">
              <div className={`${styles.label} mb-1`}>Pruebas</div>
              <div className={styles.title}>
                Vista aislada: integraciones y datos de ensayo, sin impacto en producción.
              </div>
              <div className={`${styles.sub} mt-2 text-truncate`} title={organization.name}>
                {organization.name}
              </div>
            </div>
          </div>
          <div className="d-flex flex-shrink-0 align-items-center">
            <Button
              variant="primary"
              size="sm"
              onClick={() =>
                navigate('/organization-select', {
                  state: { switchOrganization: true },
                })
              }
            >
              Cambiar organización
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SandboxEnvironmentBanner;
